export default "__VITE_ASSET__61hXCk1n__"